export function useOrganization() {
  const currentOrganization = useState<
    components['schemas']['Organization'] | null
  >('currentOrganization', () => null)

  const refreshOrganization = async () => {
    if (!currentOrganization.value) return

    const { $api } = useNuxtApp()
    await $api<components['schemas']['Organization']>(
      `/organizations/${currentOrganization.value.id}/`
    ).then((response) => (currentOrganization.value = response))
  }

  const setOrganization = (
    organization?: components['schemas']['Organization']
  ) => {
    if (!organization) return

    currentOrganization.value = organization
  }

  const clearOrganization = () => {
    currentOrganization.value = null
  }

  return {
    clearOrganization,
    currentOrganization,
    refreshOrganization,
    setOrganization,
  }
}
